var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3531 3.50938L7.99063 0.146875C7.89688 0.053125 7.77031 0 7.6375 0H1C0.723437 0 0.5 0.223437 0.5 0.5V13.5C0.5 13.7766 0.723437 14 1 14H11C11.2766 14 11.5 13.7766 11.5 13.5V3.86406C11.5 3.73125 11.4469 3.60313 11.3531 3.50938ZM10.3469 4.09375H7.40625V1.15313L10.3469 4.09375ZM10.375 12.875H1.625V1.125H6.34375V4.5C6.34375 4.67405 6.41289 4.84097 6.53596 4.96404C6.65903 5.08711 6.82595 5.15625 7 5.15625H10.375V12.875ZM5.875 8.65625H3C2.93125 8.65625 2.875 8.7125 2.875 8.78125V9.53125C2.875 9.6 2.93125 9.65625 3 9.65625H5.875C5.94375 9.65625 6 9.6 6 9.53125V8.78125C6 8.7125 5.94375 8.65625 5.875 8.65625ZM2.875 6.65625V7.40625C2.875 7.475 2.93125 7.53125 3 7.53125H9C9.06875 7.53125 9.125 7.475 9.125 7.40625V6.65625C9.125 6.5875 9.06875 6.53125 9 6.53125H3C2.93125 6.53125 2.875 6.5875 2.875 6.65625Z",
    fill: "#E00087"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file.3b1f32b7.svg";
export { ForwardRef as ReactComponent };